import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslations } from "use-intl";
import { StopsOptions } from "@/app/lib/types/enums";

const StyledToggleButton = styled(ToggleButton)(() => ({
  borderRadius: "32px !important",
  border: "1px solid #003E2B !important",
  textTransform: "none",
  padding: "6px 8px",
  minWidth: "110px",
  color: "#003E2B",
  backgroundColor: "white",
  "&.Mui-selected": {
    backgroundColor: "#003E2B",
    color: "white",
    "&:hover": {
      backgroundColor: "#003E2B",
    },
    "&:selected": {
      backgroundColor: "#003E2B",
    },
  },
}));

type Props = {
  value?: StopsOptions;
  onChange: (newValue: StopsOptions) => void;
};

export const StopsFilter = ({ value, onChange }: Props) => {
  const t = useTranslations();
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_e, newValue) => onChange(newValue)}
      className="flex w-full justify-between gap-2 py-2"
    >
      <StyledToggleButton value={StopsOptions.ANY}>
        {t("flights.any")}
      </StyledToggleButton>
      <StyledToggleButton value={StopsOptions.DIRECT}>
        {t("flights.direct")}
      </StyledToggleButton>
      <StyledToggleButton value={StopsOptions.ONE}>
        {t("flights.upToOne")}
      </StyledToggleButton>
    </ToggleButtonGroup>
  );
};
